import GiftCardSection from 'components/Checkout/Sections/Payment/GiftCardSection/GiftCardSection';
import withGlobalModals from 'hocs/withGlobalModals';

const ConnectedGiftCardSection = withGlobalModals(GiftCardSection);

export default ConnectedGiftCardSection;
